module.exports = __webpack_public_path__ + "img/client-nwa.7b8d5165.jpg";